import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../utl/models/Page";
import { LocationsState } from "../models/LocationsState";

const setPageLocations = (state: LocationsState, action: PayloadAction<Page>) => {
    state.page = action.payload.page;
}

export default setPageLocations;